import { render, staticRenderFns } from "./ActivityNotificationsForm.vue?vue&type=template&id=2642c100&"
import script from "./ActivityNotificationsForm.vue?vue&type=script&lang=js&"
export * from "./ActivityNotificationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports